import { Box, Button, Chip, Container, Paper, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Page from "../../../../components/Page";
import Breadcrumb from "../../../../components/breadcrumb/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import { getLeaveAplictions, getLeaveAplictionsforReportingHead } from "../../../../redux/features/leaveSlice";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../../../components/datagrid/GridToolBar";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { HOD_LEAVE_APPLICATION_TABLE_HEAD } from "../../../../components/datagrid/leave/HodLeaveApplicationView";
import dayjs from "dayjs";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import WfhActions from "./wfh/WfhActions";
import { ApproveLeaveActionView } from "../../../../components/datagrid/leave/RenderCellMain";
import { Icon } from "@iconify/react/dist/iconify.js";

const HodLeaveApplications = () => {
  const [gridSize, setGridSize] = useState(5);
  const [value, setValue] = useState(dayjs());
  const [selectedRow, setSelectedRow] = useState(null);
  const [wfhActionModal, setWfhActionModal] = useState(false);
  const formattedDate = `${value.year()}/${value.month() + 1}/0/0`;
  const dispatch = useDispatch();
  const { leave } = useSelector((state) => state);

  const handleDate = (newValue) => {
    setValue(newValue); 
  };

  useEffect(() => {
    dispatch(getLeaveAplictionsforReportingHead(formattedDate));
  }, [formattedDate]);

  const ApproveAction = (params) => {
    return <ApproveLeaveActionView {...params.row} />;
  };
  const columns = [
    ...HOD_LEAVE_APPLICATION_TABLE_HEAD,
    {
      field: "wfhTaskStatus",
      headerName: "WFH Task Status",
      width: 170,
      renderCell: (params) => {
        if (params.row.wfh_task_approved == null) {
          return "Nill";
        }
        if (params.row.wfh_task_approved == 0) {
          return <Chip sx={{ px: 2 }} label="Pending" color="warning" size="small" />;
        }
        if (params.row.wfh_task_approved == 1) {
          return <Chip sx={{ px: 2 }} label="Approved" color="success" size="small" />;
        }
        if (params.row.wfh_task_approved == 2) {
          return <Chip sx={{ px: 2 }} label="Rejected" color="error" size="small" />;
        }
      },
    },
    {
      field: "wfhEdit",
      headerName: "WFH Task Actions",
      width: 170,
      renderCell: (params) => {
        if (params.row.leavetype_id === 5) {
          return (
            <Button
              sx={{ boxShadow: 0 }}
              color="primary"
              startIcon={<Icon icon="fluent:apps-list-detail-24-filled" />}
              variant="contained"
              size="small"
              onClick={() => {
                setSelectedRow(params.row);
                setWfhActionModal(true);
              }}
            >
              Task Actions
            </Button>
          );
        } else {
          return "No Actions Needed";
        }
      },
    },
    {
      field: "isEditable",
      flex: 1,
      minWidth: 200,
      headerName: "Actions",
      type: "string",
      headerAlign: "left",
      align: "left",
      renderCell: ApproveAction,
    },
  ];

  return (
    <div>
      <GlobalWrapper title="Department Leave Applications">
        <Paper elevation={3} sx={{ marginTop: 4 }}>
          <Box
            sx={{
              height: 75,
              backgroundColor: "grey.200",
              borderRadius: "8px 8px 0 0",
            }}
          >
            <Box sx={{ padding: 1 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month"]}
                  label="Year and Month"
                  inputFormat="YYYY/MM"
                  value={value}
                  onChange={handleDate}
                  renderInput={(params) => <TextField {...params} helperText={null} variant="filled" />}
                />
              </LocalizationProvider>
            </Box>
          </Box>
          <DataGrid
            loading={leave.loading}
            rows={leave.applications}
            columns={columns}
            sx={{
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
            }}
            pageSize={gridSize}
            onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
            autoHeight
            rowsPerPageOptions={[5, 10, 25, 50]}
            getRowId={(row) => row.leaveId}
            components={{ Toolbar: CustomGridToolbar }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
          />
        </Paper>

        {wfhActionModal && (
          <WfhActions
            open={wfhActionModal}
            setOpen={setWfhActionModal}
            rowData={selectedRow}
            loading={leave.loading}
            formattedDate={formattedDate}
          />
        )}
      </GlobalWrapper>
    </div>
  );
};

export default HodLeaveApplications;
